/**
 * @format
 */

import axios from 'axios';
const debug = require('debug')('se:api:adserver');

const globalAnyType: any = global;

interface ZoneApi {
  init: () => void;
}

// export interface Category {
//   id: string;
//   title: string;
//   image: Image;
//   category_type?: string | null;
// }

// export interface ImageFormat {
//   name: string;
//   hash: string;
//   ext: string;
//   mime: string;
//   width: number;
//   height: number;
//   size: number;
//   path?: string;
//   url: string;
// }

// export interface Image {
//   id: number;
//   name: string;
//   alternativeText: string;
//   caption: string;
//   width: number;
//   height: number;
//   formats: {
//     thumbnail: ImageFormat;
//     large: ImageFormat;
//     medium: ImageFormat;
//     small: ImageFormat;
//   };
//   hash: string;
//   ext: string;
//   mime: string;
//   size: number;
//   url: string;
//   previewUrl?: string;
//   provider: string;
//   provider_metadata?: object;
//   created_at: string;
//   updated_at: string;
// }

// export interface Gallery {
//   id: number;
//   title: string;
//   created_at: string;
//   updated_at: string;
//   advertiser: number;
//   images: Image[];
// }

// export interface Campaign {
//   id: number;
//   name: string;
//   active: boolean;
//   start_datetime: string;
//   stop_datetime: string;
//   advertiser: number;
//   legacy_id?: number;
//   created_by_advertiser?: number;
//   default: boolean;
//   created_at: string;
//   updated_at: string;
//   publish_status: string;
// }

// export interface Advertiser {
//   id: number;
//   name: string;
//   active: boolean;
//   legacy_id?: number;
//   subscription_start_date: string;
//   subscription_end_date: string;
//   property_management_company?: number;
//   created_at: string;
//   updated_at: string;
// }

// export interface Tag {
//   id: string;
//   name: string;
// }

// export interface Icon {
//   id: string;
//   image: Image;
//   name: string;
// }

// export enum ActionType {
//   Phone = 'phone',
//   Email = 'email',
//   Web = 'web',
//   Directions = 'directions',
// }

// export interface Action {
//   id: string;
//   title: string;
//   url: string;
//   icon: Icon;
//   action_type: ActionType;
// }

// export interface BusinessLocation {
//   id: number;
//   name: string;
//   default: boolean;
//   advertiser: number;
//   street: string;
//   city: string;
//   state: string;
//   postal_code: string;
//   latitude: number;
//   longitude: number;
//   country: number;
//   unit: string;
//   contact_email?: string;
//   contact_phone?: string;
//   contact_website?: string;
//   business_hours: BusinessHour[];
// }

// export interface BusinessHour {
//   id: string;
//   day_name: string;
//   open_hours: string;
// }

// export interface FeatureType {
//   name: string;
//   text: string;
// }

// export interface Advertisement {
//   actions: Action[];
//   active: boolean;
//   advertiser: Advertiser;
//   bi_line: string;
//   body: string | null;
//   business_hours: BusinessHour[];
//   campaign: Campaign | null;
//   carousel_images: Image[] | null;
//   created_at: string;
//   featured: boolean;
//   headline: string;
//   hero_image: Image;
//   id: string;
//   legacy_id?: number;
//   promoted_feature: boolean | null;
//   show_map: boolean;
//   start_datetime: string | null;
//   stop_datetime: string | null;
//   tags: Tag[];
//   title: string | null;
//   updated_at: string;
//   hide_overlay_text: boolean;
//   feature_type: FeatureType;
//   closest_location: BusinessLocation;
//   categories: Category[];
// }

// export interface FullCategory {
//   adverts: Advertisement[];
//   featured: boolean;
//   id: string;
//   title: string;
//   age_gated_min_age: null | number;
// }

// export interface FullThumbtackCategory {
//   id: number;
//   title?: string;
//   //adverts is really categories
//   adverts?: thumbtackCategoriesObject[];
// }

// export type CategoryList = Record<string, FullCategory>;

// export interface Attachments {
//   name: string;
//   id: number;
//   url: string;
// }

// export interface NewsItem {
//   attachments: Attachments[];
//   body: string;
//   gallery: Image[];
//   id: number;
//   title: string;
//   updated_at: string;
// }

// export interface Gallery {
//   description: string;
//   images: Image[];
//   id: number;
//   title: string;
// }

// export interface thumbtackCategoriesObject {
//   id: number;
//   categoryName: string;
//   categoryDisplayName: string;
//   activeServices: number | null;
//   url: string;
//   imageURL: string;
// }

// export interface thumbtackCategoriesResponse {
//   results: [thumbtackCategoriesObject];
// }

// export interface thumbtackProsResponse {
//   results: [
//     {
//       service_id: string;
//       business_name: string;
//       rating: number;
//       num_reviews: number;
//       years_in_business: number;
//       num_hires: number;
//       thumbtack_url: string;
//       image_url: string;
//       background_image_url: string;
//       featured_review: string;
//       quote: {
//         starting_cost: number;
//       };
//     }
//   ];
// }

let adserverBase: string;
let tempServerBase: string;
let ageGatedSever: string;
// // pulling from prod since their test api doesn't work
// const thumbtackCategoriesBase =
//   'https://api.thumbtack.com/v1/partners/discoverylite/categories';
// const thumbtackProsBase =
//   'https://api.thumbtack.com/v1/partners/discoverylite/pros';
// // Config the api stuff
const ZoneApiConfig: ZoneApi = {
  init: function () {
    if (__DEV__) {
      adserverBase = globalAnyType.advertAgeApiDev;
      tempServerBase = globalAnyType.pmsApiDev;
      ageGatedSever = globalAnyType.advertAgeApiDev;
    } else {
      adserverBase = globalAnyType.advertAgeApiProd;
      tempServerBase = globalAnyType.pmsApiProd;
      ageGatedSever = globalAnyType.advertAgeApiProd;
    }
  },
};

// export const thumbtackHeaderConfig = {
//   headers: {
//     Authorization:
//       'Basic Wm9uZXRhaWw6b2FmdzdwNjhaMVNYZ3ZLQkJXSDBOU1ZLdTNzaTF1UXR6cFRXb1VoS3JNdz0=',
//   },
// };

// export async function getCategories(building: string) {
//   const url = `${ageGatedSever}/feed/${building}/categories`;
//   const { data } = await axios.get<Category[]>(url);
//   return data;
// }

// export async function getAdverts(building: string) {
//   try {
//     const url = `${adserverBase}/feed/${building}`;
//     console.log(`getAdverts(${url})`);
//     const startFetch = Date.now();
//     let response = await fetch(url, {});
//     let responseJson = await response.json();
//     console.log(
//       `advert fetch (fetch) duration: ${Date.now() - startFetch} (ms)`
//     );
//     return responseJson as unknown as CategoryList;
//   } catch (e) {
//     console.log(e);
//     return {};
//   }
// }

// export async function getGatedAdverts(building: string) {
//   try {
//     const url = `${ageGatedSever}/feed_gated/${building}`;
//     console.log(`getGatedAdverts(${url})`);
//     const startFetch = Date.now();
//     let response = await fetch(url, {});
//     let responseJson = await response.json();
//     console.log(
//       `advert gated fetch (fetch) duration: ${Date.now() - startFetch} (ms)`
//     );
//     return responseJson as unknown as CategoryList;
//   } catch (e) {
//     console.log(e);
//     return {};
//   }
// }

// export async function getAgeGatedTerms() {
//   return axios.get(`${ageGatedSever}/age-gate-terms`);
// }

// export async function submitBuildingSelectionAPI(code: string) {
//   try {
//     const url = `${tempServerBase}/condo-corporations?building_code=${code}`;
//     const { data } = await axios.get(url, headerConfig);

//     return Array.isArray(data) && data.length > 0;
//   } catch (e) {
//     console.log('api response err', e?.response?.data);
//     return false;
//   }
// }

// export async function submitNewsListAPI() {
//   const url = `${tempServerBase}/community-news?_sort=updated_at:DESC`;
//   const { data } = await axios.get(url, headerConfig);
//   return data;
// }

// export async function getGalleryListAPI() {
//   const url = `${tempServerBase}/community-galleries?_sort=updated_at:DESC`;
//   const { data } = await axios.get(url, headerConfig);
//   return data;
// }

// export async function getPropertyManagerAPI(propertyManagerId: string) {
//   const url = `${tempServerBase}/property-managers/${propertyManagerId}`;
//   const { data } = await axios.get(url, headerConfig);
//   return data;
// }

// export async function getCommunityCalendarAPI(id: string) {
//   const url = `${tempServerBase}/community-calendars/${id}`;
//   const { data } = await axios.get(url, headerConfig);
//   return data;
// }

// const utm_source = 'cma-zonetail';

// export function getZipcode(){
//   const zip_code = '90210' //= property.postal_code;
//   return zip_code;
// }

// export async function getThumbtackCategories(zip_code: string) {
//   const url = `${thumbtackCategoriesBase}?zip_code=${zip_code}&utm_source=${utm_source}`;
//   try {
//     const { data } = await axios.get(url, thumbtackHeaderConfig);
//     data.results.sort(
//       (catA: thumbtackCategoriesObject, catB: thumbtackCategoriesObject) => {
//         if (!catA.activeServices && !catB.activeServices) {
//           return 0;
//         }
//         if (!catA.activeServices && catB.activeServices) {
//           return 1;
//         }
//         if (catA.activeServices && !catB.activeServices) {
//           return -1;
//         }
//         if (catA.activeServices && catB.activeServices) {
//           if (catA.activeServices > catB.activeServices) {
//             return -1;
//           }
//           if (catA.activeServices < catB.activeServices) {
//             return 1
//           }
//         }
//         return 0;
//       }
//     );
//     data.results.map((cat: thumbtackCategoriesObject, idx: number) => {
//       cat.id = idx;
//     });
//     return data as thumbtackCategoriesResponse;
//   } catch (e: any) {
//     console.error('trouble with thumbtack category api: ', e);
//   }
// }

// export async function getThumbtackPros(zip_code: string, category: string) {
//   const url = `${thumbtackProsBase}?zip_code=${zip_code}&category=${category}&utm_source=${utm_source}`;
//   try {
//     const { data } = await axios.get(url, thumbtackHeaderConfig);
//     return data as thumbtackProsResponse;
//   } catch (e: any) {
//     console.error('trouble with thumbtack pros api: ', e);
//   }
// }

export default ZoneApiConfig;
